import { Skeleton } from '@/components/ui';

/** Placeholder for {@link BulkImportEmptyUpload} while the no-CSV panel is loading in. */
export function BulkImportEmptyUploadSkeleton() {
  return (
    <div
      className="bulk-import__empty bulk-import__empty--skeleton"
      aria-busy="true"
      aria-label="Loading upload panel"
    >
      <header className="bulk-import__empty-header">
        <Skeleton className="bulk-import__empty-skeleton-title" />
        <Skeleton className="bulk-import__empty-skeleton-system" />
      </header>

      <div className="bulk-import__empty-body">
        <div className="bulk-import__empty-dropzone bulk-import__empty-dropzone--skeleton">
          <Skeleton className="bulk-import__empty-skeleton-icon" />
          <div className="bulk-import__empty-copy">
            <Skeleton className="bulk-import__empty-skeleton-prompt" />
            <Skeleton className="bulk-import__empty-skeleton-format" />
          </div>
        </div>

        <div className="bulk-import__empty-guide">
          <Skeleton className="bulk-import__empty-skeleton-guide-title" />
          <Skeleton className="bulk-import__empty-skeleton-guide-line" />
          <Skeleton className="bulk-import__empty-skeleton-guide-line bulk-import__empty-skeleton-guide-line--short" />
          <Skeleton className="bulk-import__empty-skeleton-guide-line bulk-import__empty-skeleton-guide-line--short" />
        </div>

        <Skeleton className="bulk-import__empty-skeleton-download" />
      </div>
    </div>
  );
}
